import React from "react";
import { Form, Radio } from "antd";
import { WrapLabel, LabelWrapper, InputMargin } from "../../styles";
import { RadioOptionsWrap } from "./styles";
import { RadioButton } from "../../../../../../CommonComponents/commonStyles";

function RadioComponent(props) {
  const { property, name, radioChange, radioVal, radioValue } = props;
  return (
    <WrapLabel>
      <InputMargin marginBottom="30px">
        <RadioOptionsWrap>
          <Form.Item
            label={property && <LabelWrapper id={props.id}>{property}</LabelWrapper>}
          >
            <Radio.Group role="radiogroup" data-tid={name} onChange={radioChange} value={radioValue} aria-labelledby={props.id}>
              <RadioButton aria-label="yes" role="radio" value={radioVal[0]} data-tid={name}>Yes</RadioButton>
              <RadioButton aria-label="no" role="radio" value={radioVal[1]} data-tid={name}>No</RadioButton>
            </Radio.Group>
          </Form.Item>
        </RadioOptionsWrap>
      </InputMargin>
    </WrapLabel>
  );
}

export default RadioComponent;
